// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgXZV","clinicsSelect":"styles_clinicsSelect__6A1d3"};